import React, { Component } from 'react'
import { connect } from 'react-redux'
import { isFetching } from 'utils/redux/fetching'
import Loader from 'components/Loader'
import LineChart from 'components/LineChart'
import TinyLineChart from 'components/TinyLineChart'
import { fetchRatesHistory } from 'redux/actions/ratesHistory'
import { fetchCryptoRatesHistory } from 'redux/actions/cryptoRatesHistory'
import { fetchWeeklyCryptoRatesHistory } from 'redux/actions/weeklyCryptoRatesHistory'
import moment from 'moment'

class LineChartContainer extends Component {
	buildFromDate () {
		const { filter } = this.props
		if (filter === 'fiveYears') return moment().subtract(5,'year').format('YYYY-MM-DD')
		if (filter === 'year') return moment().subtract(1,'year').format('YYYY-MM-DD')
		if (filter === 'sixMonths') return moment().subtract(6,'months').format('YYYY-MM-DD')
		if (filter === 'threeMonths') return moment().subtract(3,'months').format('YYYY-MM-DD')
		if (filter === 'month') return moment().subtract(1,'months').format('YYYY-MM-DD')
		if (filter === 'day') return moment().subtract(1,'d').format('YYYY-MM-DD HH:mm')
		return moment().subtract(7,'d').format('YYYY-MM-DD')
	}

	componentWillMount () {
		const { dispatch, currency, mode } = this.props
		if (mode === 'monetary') {
			dispatch(fetchRatesHistory({
				from_date: this.buildFromDate(),
				to_currency_id: currency,
			}, true))
		}
		else {
			dispatch(fetchCryptoRatesHistory({
				from_date: this.buildFromDate(),
				to_crypto_currency_id: currency,
			}, true))
			dispatch(fetchWeeklyCryptoRatesHistory({
				from_date: moment().subtract(7,'d').format('YYYY-MM-DD'),
				to_crypto_currency_id: currency,
			}, true))
		}
	}

	render() {
		if (this.props.isFetching) return <Loader />

		if (this.props.tiny) return <TinyLineChart {...this.props} />

		return <LineChart fromDate={this.buildFromDate()} {...this.props} />
	}
}

const mapStateToProps = (state, props) => {
	const { ratesHistory, cryptoRatesHistory, weeklyCryptoRatesHistory } = state
	const { mode } = props
	if (mode === 'monetary' && isFetching([ratesHistory])) return { isFetching: true }
	if (mode === 'crypto' && isFetching([cryptoRatesHistory, weeklyCryptoRatesHistory])) return { isFetching: true }

	return {
		history: mode === 'monetary' ? ratesHistory : cryptoRatesHistory,
		weeklyHistory: weeklyCryptoRatesHistory
	}
}

export default connect(mapStateToProps)(LineChartContainer)
